var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56713 2.17603C7.35586 1.96476 7.00375 1.96476 6.79248 2.17603L3.16572 5.80279C2.81361 6.1549 3.06008 6.75349 3.55304 6.75349H5.80656V20.6619C5.80656 21.4014 6.40516 22 7.14459 22C7.88403 22 8.48262 21.4014 8.48262 20.6619V6.71828H10.7361C11.2291 6.71828 11.4756 6.11969 11.1235 5.76758L7.56713 2.17603Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6728 17.2465H19.9615C20.4897 17.2465 20.7362 17.8451 20.3841 18.1972L16.7573 21.8239C16.546 22.0352 16.1939 22.0352 15.9827 21.8239L12.3559 18.1972C12.0038 17.8451 12.2503 17.2465 12.7432 17.2465H14.9967V3.33803C14.9967 2.59859 15.5953 2 16.3348 2C17.0742 2 17.6728 2.59859 17.6728 3.33803V17.2465Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSort);
export default __webpack_public_path__ + "static/media/project-sort.1960750f44b493f544ccb222a309c915.svg";
export { ForwardRef as ReactComponent };